
import XHeader from 'vux/src/components/x-header/index.vue'

export default {
name: "more",
components: {
XHeader
},
data() {
return{
apps:[
{
img:'../../static/img/ccj@2x.png',
name:'查成绩',
url:'searchscore'
},{
img:'../../static/img/xf@2x.png',
name:'在线缴费',
url:'paytuition'
},
{
img:'../../static/img/hj@2x.png',
name:'缓交申请',
url:'searchscore'
},
{
img:'../../static/img/jm@2x.png',
name:'减免申请',
url:'searchscore'
},{
img:'../../static/img/dk@2x.png',
name:'贷款申请',
url:'searchscore'
},
{
img:'../../static/img/ckb@2x.png',
name:'查课表',
url:'searchscore'
},
{
img:'../../static/img/xj@2x.png',
name:'学籍信息',
url:'searchscore'
},
{
img:'../../static/img/jtxx@2x.png',
name:'家庭信息',
url:'searchscore'
},
{
img:'../../static/img/xf@2x.png',
name:'校历',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'缴费信息',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'家庭信息',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'我要吐槽',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'学院概况',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'全景校园',
url:''
},{
img:'../../static/img/xf@2x.png',
name:'院系介绍',
url:''
}
]
}

}
}



// WEBPACK FOOTER //
// ./src/components/More.vue